import get from 'lodash/get'

export const getFSTaskIdFromSession = (session) => {
  return get(session, 'focusSession.taskId')
}
